<template>
    <div>
         <div class="top" v-show='topFixed'>
            <div class='warp zb' v-if='Pid==5&&isBidder'>
                <div class="rt" v-if='!payOk'>
                    <p class='lf zbwjf'>中标服务费：<span>¥</span><span class='money'>{{serviceCharge}}</span></p>
                    <div class='rt topBtn' @click='goTb' clstag="pageclick|keycount|Pcpaimai_tender|details_pay">
                        <p class='goTb'>去支付</p>
                        <p>中标服务费</p>
                    </div>
                </div>
                <div class="rt payOk" v-else>
                    <p class='pay'>
                        已成功完成支付
                    </p>
                    <a class='link' @click='agreeXy()' clstag="pageclick|keycount|Pcpaimai_tender|details_performance">进入履约流程 ></a>
                </div>
            </div>
            <div class='warp' v-if='Pid==1||Pid==2||Pid==3'>
                <div class='rt topBtn' @click='goCg' clstag="pageclick|keycount|Pcpaimai_tender|details_bid">
                    前往招标采购页
                </div>
            </div>
        </div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item to="/ggList/1" clstag="pageclick|keycount|Pcpaimai_tender|details_crumbs_1">招标采购</el-breadcrumb-item>
            <el-breadcrumb-item to="/ggList/1" v-if='Pid==1' clstag="pageclick|keycount|Pcpaimai_tender|details_crumbs_2">招标公告</el-breadcrumb-item>
            <el-breadcrumb-item to="/ggList/2" v-if='Pid==2' clstag="pageclick|keycount|Pcpaimai_tender|details_crumbs_2">变更公告</el-breadcrumb-item>
            <el-breadcrumb-item to="/ggList/3" v-if='Pid==3' clstag="pageclick|keycount|Pcpaimai_tender|details_crumbs_2">评标公示</el-breadcrumb-item>
            <el-breadcrumb-item to="/ggList/5" v-if='Pid==5' clstag="pageclick|keycount|Pcpaimai_tender|details_crumbs_2">中标公告</el-breadcrumb-item>
            <el-breadcrumb-item>{{data.tenderName}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="bg">
            <div class='titleBox'>
                <p class='lf title'>{{data.tenderName}}</p>
                <div v-if='Pid==5&&isBidder' class='rt'>
                     <div class='goTop' v-if='!payOk'>
                        <p class='lf zbwjf'>中标服务费：<span>¥</span><span class='money'>{{serviceCharge}}</span></p>
                        <div class='rt btn-true' @click='goTb'  clstag="pageclick|keycount|Pcpaimai_tender|details_pay">
                            <p class='goTb'>去支付</p>
                            <p class='zbfwf'>中标服务费</p>
                        </div>
                    </div>
                    <div class="payOk goTop" v-else>
                        <p class='pay'>
                            已成功完成支付
                        </p>
                        <a class='link' @click='agreeXy()' clstag="pageclick|keycount|Pcpaimai_tender|details_performance">进入履约流程 ></a>
                    </div>
                </div>
                <el-button v-if='Pid==1||Pid==2||Pid==3' type='primary rt goTop' @click='goCg' style="margin:20px 0" clstag="pageclick|keycount|Pcpaimai_tender|details_bid">前往招标采购页</el-button>
            </div>
            <ul class='xmxx'>
                <li>
                    项目编号：<span>{{data.tenderNum}}</span>
                </li>
                <li>
                    项目金额：<span class='money' v-html='projectAmount(data.projectAmount)'>0.00</span><span>万元</span>
                </li>
                <li>
                    发布时间：<span  v-html='timeFormatter(data.publishTime)'></span>
                </li>
                <li>
                    截止时间：<span v-html='timeFormatter(data.endTime)'></span>
                </li>
                <li>
                    招标单位：<span>{{data.tenderUnit}}</span>
                </li>
                <li v-show='data.agency'>
                    代理机构：<span>{{data.agency}}</span>
                </li>
            </ul>
        </div>
        <div class="bg contentP5">
            <p class='modal-title'>项目介绍</p>
            <div class="gsbg" v-if='sfbg'>
                公示变更：您当前查看的<span v-if='Pid==1'>招标公告</span><span v-if='Pid==3'>评标公示</span>已发生变更，请<router-link clstag="pageclick|keycount|Pcpaimai_tender|details_jump" :to="{path:'/ggView',query:{id:this.bgggId,tenderId:this.tenderId,Pid:2}}" class='link'>点击此处</router-link>跳转查看变更公告并进行投标报名。
            </div>
            <iframe v-if='data.contentType==2' :src="data.content" frameborder="0" width="100%" height='1200px'></iframe>
            <div v-html='data.content' v-else>

            </div>
        </div>
        <!-- 用户信息授权协议弹窗 -->
        <el-dialog
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            title=""
            :visible.sync="dialogVisible"
            width="460px"
            height='210px'
            top='-115px'
            :before-close="closeXy"
            >
            <div style='padding:20px 50px 20px 30px;line-height:24px;text-align:center'>
            <p>您即将跳转至由【浙江招天下招投标交易平台有限公司】</p>
            <p>运营的招投标采购平台，请您在点击同意前，仔细阅读:</p>
                <p class='xyName'><span @click='lookXy'>《招标采购用户须知》</span></p>
                <p>您点击 "同意" ，即代表您知晓并同意《须知》全部内容;</p>
                <p>如不同意，请勿点击 "同意" 按钮。</p>
            </div>
            <div class='btn-box'>
                <el-button type="primary" @click="agreeXy">我已阅读并同意</el-button>
            </div>
        </el-dialog>
        <!-- 去支付后弹窗 -->
        <el-dialog
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            title=""
            :visible.sync="paySuccess"
            width="400px"
            height='210px'
            top='-115px'
            :before-close="closePay"
            >
            <div style='padding:20px 50px 20px 30px;line-height:24px;text-align:center'>
                <h3 style='color:#333;font-size:16px;margin-bottom:10px'>请在新打开的页面完成支付</h3>
                <p>支付完成前请不要关闭此窗口</p>
            </div>
            <div class='btn-box'>
                <el-button type="primary" @click="closePay">已完成支付</el-button>
            </div>
        </el-dialog>
        <!-- 登录状态 -->
        <!-- 个人账户 -->
        <!-- 实名认证 -->
    </div>
</template>
<script>
export default {
    name:'zhaoBiaoView',
    data(){
        return{
            data:{},
            topFixed:false,//是否显示顶部按钮
            dialogVisible:false,//协议弹窗
            Pid:1,//公告类型
            ggId:'',//招标公告id
            tenderId:'',//招标项目id,
            sfbg:false,//是否已经变更公告
            bgggId:'',//变更公告Id
            payOk:false,//是否支付成功
            isBidder:false,//是否中标人,
            tenderNum:'',//传给招天下后台,
            serviceCharge:'',
            paySuccess:false,
        }
    },
    watch:{
        '$route' () {
            this.$router.go(0)
        }
    },
    methods:{
        //获取公告内容
        getData(){
            let para={
                id:this.ggId
            } 
            this.$api.ggView(para).then(res=>{
                if(res.data.code==0){
                    this.data=res.data.data
                    this.tenderNum=res.data.data.tenderNum
                }else{
                    this.$message.error(res.data.message)
                }
            }).catch(()=>{
                
            });
        },
        //获取是否有变更公告
        getSfbg(){
            var num;
            if(this.Pid==1){
                num=2;
            }else if(this.Pid==3){
                num=4;
            }
            let para={
                tenderId:this.tenderId,
                type:num
            }
            this.$api.sfbgView(para).then(res=>{
                if(res.data.code==0){
                     if(res.data.data){
                        this.bgggId=res.data.data;
                        this.sfbg=true
                    }else{
                        this.sfbg=false
                    } 
                }else{
                    this.$message.error(res.data.message)
                }
            }).catch(()=>{
                
            });

        },
        //我要投标
        goTb(){
            this.paySuccess=true;
            //去收银台
            let para={
                tenderId:this.tenderId, 
                serviceCharge:this.serviceCharge  
            }
            this.$api.goPay(para).then(res=>{
                if(res.data.code==0){
                    let url=res.data.data
                    window.open(url)
                }else{
                    this.$message.error(res.data.message)
                }
            }).catch(()=>{})
        },
        //前往招标采购页
        goCg(){
            this.dialogVisible=true
        },
        //查看协议
        lookXy(){
            window.open('../《招标采购用户须知》.pdf')
        },
        //同意协议
        agreeXy(){
            this.isAuthenticate()
            //接下去操作
        },
        //关闭弹窗
        closeXy(){
            this.dialogVisible=false
        },
        //关闭弹窗并刷新页面
        closePay(){
            this.paySuccess=false;
            this.getBidder();
        },
        //查询中标信息及中标服务费
        getBidder(){
            let para={
                tenderId:this.tenderId,
            }
            this.$api.getBidder(para).then(res=>{
                if(res.data.code==0){
                    if(!res.data.data||res.data.data.bidStatus==0){
                        //未中标
                        this.isBidder=false
                    }else{
                        //bidStatus:0:有意向 1:中标
                        //payStatus:0：未支付 1:已支付
                        if(res.data.data.payStatus==1){
                            this.payOk=true
                        }else{
                            this.payOk=false
                        }
                        //中标人
                        this.isBidder=true
                        this.serviceCharge=res.data.data.serviceCharge
                    }
                }else{
                    this.$message.error(res.data.message)
                }
            }).catch(()=>{})
        },
        //是否实名
        isAuthenticate(){
            this.$api.isAuthenticate().then((res)=>{
                if(res.data.code==0){
                    if(res.data.data=="SUCCESS"){
                        this.$message({
                            message: '成功',
                            type: 'success'
                        });
                        //已经实名的则获取token
                        this.getToken();
                    }else if(res.data.data=="NOT_AUTHENTICATION"){
                        let path=window.location.href
                        window.open('https://qyrz.jd.com/realName/index.htm?source=JDPM-PC-ZBCG&r='+path+'&bussCode=SF_QY2')
                    }else if(res.data.data=="PERSONAL_LOGIN"){
                        this.$message({
                            message: '目前不允许个人账号参与投标，请您切换至企业账号参与投标流程。',
                            type: 'warning'
                        });
                    }
                    this.dialogVisible=false;
                }else{
                    this.$message.error(res.data.message)
                    this.dialogVisible=false;
                }
            }).catch(()=>{

            })
        },
        //获取token
        getToken(){
            let para={
                tenderId:this.tenderId
            }
            this.$api.getToken(para).then(res=>{
                if(res.data.code==0){
                    let pin=res.data.data
                    //去招天下页面接口
                    window.open('https://jypt.zhaotx.cn/jdUserJson?secretPin='+pin+'&bdbh='+ this.tenderNum+'&id='+this.ggId+'&Pid='+this.Pid+'&tenderId='+this.tenderId)
                    this.dialogVisible=false;
                }else{
                    this.$message.error(res.data.message)
                }
            }).catch(()=>{
            })
        },
        //页面滚动
         handleScroll(){
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            if(document.querySelector('.goTop')){
                 var offsetTop = document.querySelector('.goTop').offsetTop;
            
                if (scrollTop > offsetTop&&offsetTop!=0) {

                    this.topFixed = true
                } else {
                    this.topFixed = false
                }
            }
        },
        //时间格式化
        timeFormatter(time){
            if(time){
                time = new Date(time);
                let y = time.getFullYear();
                let mon = (time.getMonth()+1)<10?'0'+(time.getMonth()+1):time.getMonth()+1;
                let d = time.getDate()<10?('0'+time.getDate()):time.getDate();
                return y +'-'+ mon +'-'+ d;
            }
            return ''
        },
        //格式化项目金额
        projectAmount(val){
            if(val){
                let y=String(val/10000).split('.');
                if(y[1]){
                    if(y[1].length==1){
                        return val/10000+"0"
                    }else if(y[1].length>=2){
                        return val/10000
                    }
                }else{
                    return val/10000+".00"
                }
            }
        }
    },
    mounted(){
        function IEVersion() {
        var userAgent = navigator.userAgent;            //判断是否IE浏览器            
        var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1;    
        if (isIE){ 
            var reIE = new RegExp("MSIE (\\d+\\.\\d+);");               
                reIE.test(userAgent);                
            var fIEVersion = parseFloat(RegExp["$1"]);                
                if (fIEVersion < 10 ) {                    
                        return true; 
                } else {
                    return false;   
                }
        }  
         }
        if (IEVersion()) {
            alert('当前浏览器版本过低，请升级到IE10及以上版本！') 
        }else{
            this.ggId=this.$route.query.id;
            this.Pid=this.$route.query.Pid;
            this.tenderId=this.$route.query.tenderId;
            this.getData();
            //招标公告和评标公示页面查询是否有变更公告
            if(this.Pid==1||this.Pid==3){
                this.getSfbg();
            }
            //中标页面查询中标情况
            if(this.Pid==5){
                this.getBidder();
            }
            window.addEventListener('scroll', this.handleScroll)
        }
    },
    destroyed(){
        window.removeEventListener('scroll',this.handleScroll);
    }
}
</script>
<style lang="less">
.zbgg .titleBox p.title{
    line-height:56px;
}
.zbwjf{
    line-height:54px;
    span{
        color:#cc2729;
        font-weight: bold;
        font-size: 18px;
    }
    span.money{
        font-size: 24px;
        margin-left:5px;
    }
}
.btn-true {
    border-radius: 4px;
    background: #cc2729;
    color: #fff;
    padding: 5px 25px;
    min-height: 40px;
    text-align: center;
    margin-left: 20px;
    cursor: pointer;
}
.top div.warp.zb  .topBtn{
    margin-left:24px;
    padding:5px 15px;
    p {
        font-size: 13px;
        line-height:18px;
    }
    p.goTb {
        line-height:28px;
        font-size: 20px;
        font-weight: bold;
    }
}
p.goTb{
    font-size: 20px;
    font-weight: bold;
    line-height:28px;
}
p.zbfwf{
    line-height:18px;
    font-size:14px;
}
.top{
    .payOk{
        padding-top:5px;
    }
}
.payOk{
    text-align: right;
    .pay{
        padding-left:25px;
        color:#666;
        font-size: 18px;
        height:25px;
        line-height:25px;
        margin-bottom:5px;
        background:url('../assets/duigou.png') no-repeat left center;
    }
    .link{
        font-size: 13px;
    }
}
.goTop{
    margin:13px 0;
}
.el-dialog__wrapper{
    background: rgba(255,255,255,0.90);
    border-radius: 2px;
}
p.xyName{
    margin:5px 0;
    text-align:center;
    span{
        color:#2db7f5;
        cursor:pointer;
    }
    span:hover{
        text-decoration: underline;
    }
}
</style>